// MARK://dhk8/admin-shell/lib/queries/print-stations
// Query tipada de estaciones de impresión — F3.4 / ADR-0009. El Admin lee las
// estaciones por el grafo (pos-printing), tenant del JWT. Escrituras siguen REST.
import { graphql } from '../../gql/index.js'

export const AdminPrintStationsQuery = graphql(`
  query AdminPrintStations {
    printStations {
      id
      tenantId
      branchId
      name
      sortOrder
    }
  }
`)
